import React from "react";
import styled from "styled-components";

export default function Button({
  href,
  children,
  target = "_blank",
  rel = "noopener noreferrer",
  variant = "primary",
  disableHoverLift = false,
  disableShadow = false,
}) {
  return (
    <StyledButton
      href={href}
      target={target}
      rel={rel}
      $variant={variant}
      $disableHoverLift={disableHoverLift}
      $disableShadow={disableShadow}
    >
      {children}
    </StyledButton>
  );
}

const StyledButton = styled.a`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.75rem;
  min-height: 56px;
  padding: 0.95rem 1.4rem;
  border-radius: 999px;
  border: 1px solid
    ${({ theme, $variant }) =>
      $variant === "secondary"
        ? theme.colors.border
        : "rgba(45, 167, 183, 0.2)"};
  background: ${({ theme, $variant }) =>
    $variant === "secondary"
      ? theme.colors.secondaryButtonBackground
      : `linear-gradient(
          135deg,
          ${theme.colors.primaryButtonStart} 0%,
          ${theme.colors.primaryButtonEnd} 100%
        )`};
  color: ${({ theme, $variant }) =>
    $variant === "secondary" ? theme.colors.ink : "#fff"};
  box-shadow: ${({ $variant, $disableShadow }) =>
    $variant === "secondary" || $disableShadow
      ? "none"
      : "0 18px 32px rgba(45, 167, 183, 0.24)"};
  font-size: 0.96rem;
  font-weight: 700;
  letter-spacing: 0.01em;
  transition:
    transform 0.2s ease,
    box-shadow 0.2s ease,
    background 0.2s ease,
    border-color 0.2s ease;

  &:hover {
    transform: ${({ $disableHoverLift }) =>
      $disableHoverLift ? "none" : "translateY(-2px)"};
    background: ${({ theme, $variant }) =>
      $variant === "secondary"
        ? theme.colors.secondaryButtonBackground
        : `linear-gradient(
            135deg,
            ${theme.colors.primaryButtonHoverStart} 0%,
            ${theme.colors.primaryButtonHoverEnd} 100%
          )`};
    border-color: ${({ theme, $variant, $disableHoverLift }) =>
      $variant === "secondary" || $disableHoverLift
        ? theme.colors.accentDark
        : "rgba(45, 167, 183, 0.2)"};
    box-shadow: ${({ theme, $variant, $disableShadow }) =>
      $disableShadow
        ? "none"
        : $variant === "secondary"
          ? theme.colors.secondaryButtonHoverShadow
        : "0 22px 40px rgba(45, 167, 183, 0.28)"};
  }

  &:focus-visible {
    border-color: ${({ theme }) => theme.colors.accentDark};
  }
`;
